import config from "config";
import { OktaAuth } from "@okta/okta-auth-js";

const oktaLogout = async (oktaAuth: OktaAuth) => {
  const {
    auth: { postLogoutRedirectUri },
  } = config.get();

  const signOutProps =
    postLogoutRedirectUri && !config.isInstanceManagement()
      ? {
          postLogoutRedirectUri,
        }
      : undefined;

  try {
    await oktaAuth.signOut(signOutProps);
  } catch (err) {
    console.error(err);
  }
};

export default oktaLogout;
